import store from '@carvana/purchase-store';
import { datadogRum } from '@datadog/browser-rum';
import Experiments from '../experiments';

const UserBucketedInExperiment = experiment => {
  const allExperiments = Experiments.initialize().addExperiment(experiment);
  const payload = {
    experiment,
    experiments: allExperiments.list
  };
  const experimentsAsObject = Experiments.toObject(allExperiments);

  datadogRum.setGlobalContextProperty('experiments', experimentsAsObject);

  return store.dispatch({
    type: '@@EXPERIMENT_USER_BUCKETED',
    payload
  });
};

export default UserBucketedInExperiment;
